import { render } from "./SectionTravel.vue?vue&type=template&id=1bcbaeaa&scoped=true"
import script from "./SectionTravel.vue?vue&type=script&lang=js"
export * from "./SectionTravel.vue?vue&type=script&lang=js"

import "./SectionTravel.vue?vue&type=style&index=0&id=1bcbaeaa&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcbaeaa"]])

export default __exports__